// Product and gift-set cards, used by every grid and rail on the site.
import { R, esc } from '../lib/format.js';
import { img } from '../lib/media.js';

const plus = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M7 1v12M1 7h12"/></svg>';
// cards are about a fifth of the page wide on desktop and just under half on phones
export const CARD_SIZES = '(min-width: 1400px) 280px, (min-width: 900px) 22vw, 46vw';

export function productCard(p, { url, sizes = CARD_SIZES, badge = true, lazy = true } = {}) {
  const href = url(p.id);
  // a real photo first (catalog `photos`); pointing at the card shows the next one, or the catalogue shot
  const [main, next] = p.photos?.length ? p.photos : [p.img], alt = next || [p.worn, p.img].find(x => x && x !== main);
  const pill = !badge ? '' : !p.available ? '<span class="pill sold">Sold out</span>' : (p.tag === 'new' ? '<span class="pill">New</span>' : '');
  return `<article class="card${p.available ? '' : ' is-sold'}" data-pid="${esc(p.id)}">
      <div class="img">${pill}
        ${p.available ? `<button type="button" class="add" data-add="${esc(p.id)}" aria-label="Add ${esc(p.name)} to bag">${plus}</button>` : ''}
        <a href="${href}" tabindex="-1" aria-hidden="true" data-vt-src>${img(main, { alt: p.name, sizes, lazy })}${alt ? img(alt, { cls: 'alt', sizes }) : ''}</a>
      </div>
      <h3><a href="${href}">${esc(p.name)}</a></h3><p class="meaning">${esc(p.meaning)}</p>
      <div class="price">${p.was ? `<s><span class="sr">Was </span>${R(p.was)}</s>` : ''}<span>${p.was ? '<span class="sr">Now </span>' : ''}${R(p.price)}</span></div>
    </article>`;
}

export function setCard(s, byId, { sizes = '(min-width: 900px) 12vw, 24vw', lazy = true } = {}) {
  const off = Math.round((1 - s.price / s.was) * 100);
  const soldOut = s.items.some(i => !byId[i].available);
  return `<article class="card${soldOut ? ' is-sold' : ''}" data-pid="${esc(s.id)}">
      <div class="img set-img${s.items.length === 2 ? ' two' : ''}">${soldOut ? '<span class="pill sold">Sold out</span>' : `<button type="button" class="add" data-add="${esc(s.id)}" aria-label="Add ${esc(s.name)} to bag">${plus}</button>`}
        ${s.items.map(i => img(byId[i].img, { sizes, lazy })).join('')}</div>
      <h3>${esc(s.name)}</h3><p class="meaning">${esc(s.meaning)}</p>
      <div class="price"><s><span class="sr">Was </span>${R(s.was)}</s><span><span class="sr">Now </span>${R(s.price)}</span><span class="off">${off}% OFF</span></div>
    </article>`;
}

// a row of skeleton cards, shown while a grid fills
export const skeletonCards = (n = 4) => Array.from({ length: n }, () => '<article class="card sk" aria-hidden="true"><div class="img"></div><h3>&nbsp;</h3><p class="meaning">&nbsp;</p></article>').join('');
